let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gw63h")).then(() => parcelRequire('6eDlo'));